import React, { PureComponent } from 'react';
import ReactPlaceholder from 'react-placeholder';
import { TextBlock } from 'react-placeholder/lib/placeholders';
import { Box } from '@mui/material';

export default function asyncComponent(importComponent) {
  class AsyncFunc extends PureComponent {
    constructor(props) {
      super(props);
      this.state = {
        Component: null,
      };
    }

    async componentDidMount() {
      // eslint-disable-next-line no-shadow
      const { default: Component } = await importComponent();
      // eslint-disable-next-line react/no-did-mount-set-state
      this.setState({ Component });
    }

    render() {
      const { Component } = this.state;

      return (
        // The padding must apply to the loading skeleton only (when ready,
        // ReactPlaceholder renders children bare), so it lives on a custom
        // placeholder rather than a wrapper around the whole boundary.
        <ReactPlaceholder
          customPlaceholder={
            <Box sx={{ p: 3 }}>
              <TextBlock rows={8} color="#CDCDCD" />
            </Box>
          }
          ready={!!Component}
        >
          {Component ? <Component {...this.props} /> : <div />}
        </ReactPlaceholder>
      );
    }
  }

  return AsyncFunc;
}
